import React, { useState, useEffect } from "react";
import style from './mobilePagination.module.scss';
import toPersianNumber from "../../helpers/actions/toPersianNumber";
import toEnglishNumber from "../../helpers/actions/toEnglishNumber";

const MobilePagination = (props) => {
    const [page, setPage] = useState({ number: props.currentPage })

    const handleClick = e => {
        let tmp = page
        tmp.number = toEnglishNumber(e.target.value)
        setPage({ ...tmp })
        delayedSearch(page.number)
    }

    const delayedSearch = number => {
        if (number != '' && number > 0 && number <= props.pageCount) {
            setTimeout(() => {
                props.setPage(page.number)
            }, 3000)
        }
    }

    return (
        <div className={style.wrapper}>
            {props.currentPage !== 1 ? <div onClick={() => props.setPage(props.currentPage - 1)} className={style.prevArrow}></div> : <div className={style.grayPrevArrow}></div>}
            <div className={style.numbersBar}>
                <p>صفحه</p>
                <input value={toPersianNumber(page.number)} onChange={e => handleClick(e)} className={style.inputStyle}></input>
                <p> از {toPersianNumber(props.pageCount)}</p>
            </div>
            {props.currentPage !== props.pageCount ? <div onClick={() => props.setPage(props.currentPage + 1)} className={style.nextArrow}></div> : <div className={style.grayNextArrow}></div>}
        </div>
    )
}
export default MobilePagination